<template>
  <div class="band pushFooter">
    <div class="bandContent mainPage dontPadExtra">
      <div
        v-if="$route.params.errorId === 'norepochosen'"
        class="section smallBottomMargin"
      >
        <div class="sectionTitle">
          <a @click="chooseRepo">Choose repo</a>
        </div>
      </div>
      <div v-else-if="$route.params.errorId === 'norepos'">
        <h2>No Repos Defined</h2>
        <p>
          Please refer to the <a
            :href="docURL"
            target="_blank"
          >RStudio Package Manager Admin Guide</a> or the <a
            :href="quickStartURL"
            target="_blank"
          >Quick Start Guides</a>, or contact an administrator to create a new repo.
        </p>
      </div>
      <div v-else>
        <p>Error: {{ $route.params.errorId }}</p>
      </div>
    </div>
  </div>
</template>

<script>

import * as types from '../store/mutation-types'
import { serverPath } from '../api/http-common'
import { mapState } from 'vuex'
import * as messageTypes from '../constants/message-types'

export default {
  name: 'Error',
  computed: {
    ...mapState({
      gotRepos: state => state.repos.gotRepos,
      allRepos: state => state.repos.allRepos,
    }),
    docURL: function () {
      return `${serverPath()}__docs__/admin`
    },
    quickStartURL: function () {
      return `${serverPath()}__docs__/admin/getting-started/configuration/`
    },
  },
  watch: {
    allRepos: function (value) {
      this.$store.commit(types.SET_STATUS_MESSAGE, null)
      if (value && value.length > 0) {
        this.$router.replace({ name: 'home' })
      }
    },
  },
  created: function () {
    this.$store.commit(types.SET_SHRINK_HEADER, false)
    this.$store.commit(types.SET_SHOW_FOOTER, true)
    this.$store.commit(types.SET_MENU_ITEMS, { menuItems: [] })
    this.$store.commit(types.SET_NAV_TOGGLER_AS_NEEDED, true)
    this.$store.commit(types.SET_HEADER_TITLE, '')
    const desiredRepoId = this.$route.params ? +this.$route.params.repoId : undefined
    if (!this.gotRepos) {
      this.$store.dispatch('getAllRepos', desiredRepoId)
      this.$store.commit(types.SET_STATUS_MESSAGE, { type: messageTypes.ACTIVITY_MESSAGE, message: 'Checking for Repos' })
    }
  },
  mounted: function () {
    if (this.$route.params && this.$route.params.errorId === 'norepochosen') {
      this.$store.commit(types.SET_SHOW_NAV_PANEL, true)
    }
  },
  methods: {
    chooseRepo: function (event) {
      this.$store.commit(types.SET_SHOW_NAV_PANEL, true)
    },
  },
}
</script>
